<div *ngIf="(loader$ | async)"
     class="container-fullscreen">
  <div class="loader">
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
  </div>
</div>
